import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { adminResetPassword } from '../api/adminApi';
import { toast } from 'react-toastify';

const AdminResetPassword = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [token, setToken] = useState('');

    useEffect(() => {
        const resetToken = searchParams.get('token');
        if (!resetToken) {
            setError('Invalid or missing reset token');
            return;
        }
        setToken(resetToken);
    }, [searchParams]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match');
            setLoading(false);
            return;
        }

        try {
            await adminResetPassword(token, formData.password);
            toast.success('Password reset successful!');
            navigate('/admin/login');
        } catch (error) {
            console.error('Reset password error:', error);
            setError(error.response?.data?.error || error.message || 'An error occurred while resetting your password');
            toast.error(error.response?.data?.error || error.message || 'An error occurred while resetting your password');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fullscreen-container">
            <div className="card w-full max-w-md p-8">
                <h2 className="text-2xl font-bold text-center mb-6">Reset Admin Password</h2>
                <form className="space-y-6" onSubmit={handleSubmit}>
                    {error && (
                        <div className="bg-red-500/20 text-red-400 p-3 rounded-lg text-center">
                            {error}
                        </div>
                    )}
                    <div>
                        <label htmlFor="password" className="sr-only">New Password</label>
                        <input
                            id="password"
                            name="password"
                            type="password"
                            required
                            className="input-field"
                            placeholder="New Password"
                            value={formData.password}
                            onChange={handleChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="confirmPassword" className="sr-only">Confirm New Password</label>
                        <input
                            id="confirmPassword"
                            name="confirmPassword"
                            type="password"
                            required
                            className="input-field"
                            placeholder="Confirm New Password"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading || !token}
                        className="btn btn-primary w-full"
                    >
                        {loading ? 'Resetting...' : 'Reset Password'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminResetPassword;